import React, { useEffect, useState, useRef } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import DeviceRegistGridHeader from './DeviceRegistGridHeader';
import DeviceRegistGridBody from './DeviceRegistGridBody';
import DeviceRegistFooter from './DeviceRegistFooter';
import { SettingsState } from '../../../organisms/SelectSettings';
import { NAME_DEV_SET, GetNameDevSetList, SetNameDevSetList } from '../../../../function/NameDevSetModel';
import { useModal } from '../../../../function/useModal';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../../atoms/Dialog/MessageDialog';
import { useTranslation } from 'react-i18next';
import ReadDevCsvDialog from './../../../molecules/Dialog/ReadDevCsvDialog/ReadDevCsvDialogPage';
import { DeviceRegistPageStyle, TableBaseStyle } from './DeviceRegistStyle';
import DeviceRegistSettingDialog, { DeviceRegistNewDialogResponse } from './DeviceRegistSettingDialog';
type DeviceRegistProps = {
  editData: SettingsState;
};

const useStyles = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 316px)',
    },
    tableDialgContainer: {
      maxHeight: 'calc(100vh - 276px)',
    },
    tableHeader: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      borderCollapse: `collapse`,
    },
    headerCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
    bodyCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0.5px',
      height: '10px',
      textAlign: 'center',
    },
    tableTd: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0px',
      minWidth: '80px',
    },
    colTime: {
      textAlign: 'center',
    },
    //テキスト
    textField: {
      flexGrow: 1,
      height: '100%',
      width: '98%',
      border: 'none',
      backgroundColor: 'transparent',
      textAlign: 'center',
    },
  })
);

const DeviceRegist: React.FC<DeviceRegistProps> = (props: DeviceRegistProps) => {
  const { t } = useTranslation();
  const pageStyle = DeviceRegistPageStyle();
  const tableBaseStyle = TableBaseStyle();
  const [devList, setDevList] = useState<NAME_DEV_SET[]>([]);
  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [dlgmsg, setDlgmsg] = useState<string>('');
  const [buttonEnable, setButtonEnable] = useState<boolean>(true);
  const [index, setIndex] = useState<number>(0);
  const [selectedID, setSelectedID] = useState(0);

  const [openReadCSVDlg, setOpenReadCSVDlg] = useState<boolean>(false); //危機管理台帳読込

  const fileObjectData = useRef<File>();
  const [isUpdateDisp, setIsUpdateDisp] = useState<boolean>(false);
  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('DeviceRegist.はい', 'はい')}
      cancel={t('DeviceRegist.いいえ', 'いいえ')}
    />
  ) : null;
  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  // レアショート/振動(速度)&振動(変位)設定ダイアログ
  const [flgSettingRowDlg, settingRowDlg] = useModal<DeviceRegistNewDialogResponse>();

  useEffect(() => {
    setButtonEnable(false);
    GetNameDevSetList()
      .then((res) => {
        setDevList(res);
        props.editData.SaveFunction = saveProc;
        props.editData.IsUpdate = false;
        setButtonEnable(true);
      })
      .catch((e) => {
        setDlgmsg(t('DeviceRegist.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
      })
      .finally(() => {

        setButtonEnable(true);
      });
  }, [isUpdateDisp, props.editData.CancelCondition]);

  const updateDev = (item: NAME_DEV_SET) => {
    const idx = devList.findIndex((srch) => srch.DEV_INDEX == item.DEV_INDEX);
    if (idx >= 0) {
      devList[idx] = item;
      props.editData.Target = devList;
      props.editData.IsUpdate = true;
    }
  };

  const saveAction = () => {
    setDlgmsg(t('DeviceRegist.保存しますか?', '保存しますか?'));
    actCfmDlg
      .open()
      .apply((_) => {
        setButtonEnable(false);
        saveProc(devList).finally(() => {
          setButtonEnable(true);
        });
      })
      .cancel(() => { });
  };

  /**
   * 保存
   */
  const saveProc = (target: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const devList = target as NAME_DEV_SET[];
      if (devList) {
        SetNameDevSetList(devList)
          .then((res) => {
            console.debug(`SetNameDevSetList res : ${res}`);
            if (res == 200) {
              props.editData.IsUpdate = false;
              setIsUpdateDisp(!isUpdateDisp);

              // props.editData.CloseSetting();
              resolve('done');
            } else {
              reject('update fault');
            }
          })
          .catch((error) => {
            console.error('SetNameDevSetList : ' + error);
          });
      } else {
        reject('data error');
      }
    });
  };
  /**
   * キャンセル
   */
  const cancelAction = () => {
    if (props.editData.IsUpdate) {
      setDlgmsg(
        t(
          'DeviceRegist.保存していないデータを破棄します。\nよろしいですか?',
          '保存していないデータを破棄します。\nよろしいですか?'
        )
      );
      actCfmDlg
        .open()
        .apply((_) => {
          // props.editData.IsUpdate = false;
          setDevList([]);
          props.editData.UpdateCancel();
          // props.editData.CloseSetting();
        })
        .cancel(() => { });
    } else {
      // props.editData.CloseSetting();
    }
  };
  /**
   * レアショート/振動(速度)&振動(変位)選択画面
   * @param devIndex 
   */
  const newAction = (devIndex: number) => {
    //ダイアログに機器番号を渡す
    setIndex(devIndex);
    settingRowDlg
      .open()
      .apply(() => {
        // API実行成功後のコールバック

        console.debug('apply()');
        //updateData();
      })
      .cancel(() => {
        console.debug('cancel()');
        //updateData();
      });
  }
  /**
   * 機器管理台帳読込ボタン押下
   */
  const readDevCsvDlgOpenAction = (fileObject: File) => {
    fileObjectData.current = fileObject;
    setOpenReadCSVDlg(true);
    console.debug(['DeviceRegist - readDevCsvDlgOpenActionEx']);
  };
  /**
   * 機器管理台帳読込閉じる
   */
  const readDevCsvDlgCloseAction = (updateFlg: boolean) => {
    setOpenReadCSVDlg(false);
    if (updateFlg) {
      setDevList([]);
      props.editData.UpdateCancel();
    }
  };

  return (
    <>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 2 }}>
        <Grid item xs={12}>
          <TableContainer component={Paper} className={pageStyle.tableContainer}>
            <Table stickyHeader aria-label="a dense table">
              <TableHead>
                <DeviceRegistGridHeader />
              </TableHead>
              <TableBody>
                {devList.map((dev, index) => {
                  return <DeviceRegistGridBody key={index} item={dev} seectId={selectedID} updateItem={updateDev} onClickSettingButton={newAction} selectedID={setSelectedID} />;
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12}>
          <DeviceRegistFooter
            onClickSaveButton={saveAction}
            onClickCancelButton={cancelAction}
            onClickReadCSVButton={readDevCsvDlgOpenAction}
            buttonEnable={buttonEnable}
          ></DeviceRegistFooter>
        </Grid>
      </Grid>
      {/* レアショート/振動(速度)&振動(変位)設定画面 */}
      {flgSettingRowDlg ? (
        <DeviceRegistSettingDialog
          dialog={settingRowDlg}
          index={index}
        />
      ) : null}
      {cfmdlg}
      {msgdlg}
      <ReadDevCsvDialog
        open={openReadCSVDlg}
        onClose={readDevCsvDlgCloseAction}
        tableContainerStyle={pageStyle.tableDialgContainer}
        headerCellStyle={tableBaseStyle.headerCell}
        bodyCellStyle={tableBaseStyle.bodyCellCenter}
        textFieldStyle={tableBaseStyle.textField}
        fileObject={fileObjectData.current}
      ></ReadDevCsvDialog>
    </>
  );
};

export default DeviceRegist;
